import React, { useEffect, useState } from "react";
import Layout from "../../components/layout/Layout";
import Pagination from "./../../components/Pagination";
import { connect, useDispatch, useSelector } from "react-redux";
import { ToastContainer } from "react-toastify";
import dateFormat from "dateformat";
import {
  affiliateList,
  updateAffiliateStatus,
  affiliateDelete,
} from "../../redux/action/affiliate";
import { APIURL } from "../../redux/action/config";
import loader from "../../components/loader/loader";
import ViewAffiliate from "./ViewAffiliate";

const AffiliateList = ({ pageLoading, affiliateListData, not_found }) => {
  const [productDataList, setProductDataList] = useState([]);
  const onChangePage = (pageOfItems) => {
    setProductDataList(pageOfItems);
  };
  const [viewDetails, setViewDetails] = useState();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(affiliateList());
  }, [dispatch]);

  const getBadge = (status) => {
    switch (status) {
      case "approved":
        return "success";
      case "rejected":
        return "danger";
      default:
        return "warning";
    }
  };

  const handleStatusChange = (id, status) => {
    dispatch(updateAffiliateStatus(id, status));
    setTimeout(() => {
      dispatch(affiliateList());
    }, 1000);
  };

  const handleDelete = async (id) => {
    const res = await dispatch(affiliateDelete(id));
    if (res?.success) {
      setProductDataList(productDataList.filter((a) => a._id != id));
    }
    setTimeout(() => {
      dispatch(affiliateList());
    }, 1000);
  };

  const handleGetId = (e, id) => {
    e?.preventDefault();
    if (!id) return;
    setViewDetails("");
    const token = localStorage.getItem("token");
    var myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${token}`);

    var requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    fetch(`${APIURL}/api/v1/affiliate/${id}`, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        setViewDetails(result?.data?.affiliate);
      })
      .catch((error) => console.log("error", error));
  };

  const AffiliateData = affiliateListData?.data?.affiliate
    ? affiliateListData?.data?.affiliate
    : "";

  return (
    <React.Fragment>
      <ToastContainer autoClose={2000} />

      <Layout title="Affiliate Applications" page="affiliate">
        <div
          className="content d-flex flex-column flex-column-fluid"
          id="kt_content"
        >
          <div id="kt_content_container" className="container-fluid">
            <div className="row g-5 g-xxl-10">
              <div className="col-xl-12 col-xxl-12 mb-5 mb-xxl-12">
                <div
                  id="kt_datatable_example_5_wrapper"
                  className="dataTables_wrapper dt-bootstrap4 no-footer"
                >
                  <div className="table-responsive table-wrapper">
                    <table
                      id="kt_datatable_example_5"
                      className="table table-striped table-row-bordered gy-5 gs-7 border rounded dataTable no-footer status"
                    >
                      <thead>
                        <tr className="fw-bolder fs-6 text-gray-800 px-7 arrow-none">
                          <th>Contact Name</th>
                          <th>Business Name</th>
                          <th>Email Address</th>
                          <th>Phone Number</th>
                          <th>Business Type</th>
                          <th>Submitted On</th>
                          <th>Status</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {!pageLoading && productDataList?.length ? (
                          productDataList?.map((item, index) => {
                            return (
                              <tr key={index} className="pro-list-info">
                                <td>{item.contactName}</td>
                                <td>{item.businessName}</td>
                                <td>{item.email}</td>
                                <td>{item.phone}</td>
                                <td>{item.businessType}</td>
                                <td>
                                  {item.createdAt
                                    ? dateFormat(item.createdAt, "mmm d, yyyy")
                                    : "-"}
                                </td>
                                <td>
                                  <select
                                    className={`btn ${getBadge(item.status)}`}
                                    value={item.status}
                                    onChange={(e) =>
                                      handleStatusChange(
                                        item._id,
                                        e.target.value
                                      )
                                    }
                                  >
                                    <option value="pending">Pending</option>
                                    <option value="approved">Approved</option>
                                    <option value="rejected">Rejected</option>
                                  </select>
                                </td>
                                <td>
                                  <a
                                    type="button"
                                    onClick={(e) => handleGetId(e, item?._id)}
                                    className="btn btn-primary"
                                    data-bs-toggle="modal"
                                    data-bs-target="#affiliateDetailModal"
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="16"
                                      height="16"
                                      fill="currentColor"
                                      className="bi bi-eye-fill"
                                      viewBox="0 0 16 16"
                                    >
                                      <path d="M10.5 8a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0z" />
                                      <path d="M0 8s3-5.5 8-5.5S16 8 16 8s-3 5.5-8 5.5S0 8 0 8zm8 3.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7z" />
                                    </svg>
                                  </a>
                                  <ViewAffiliate
                                    modalId={"affiliateDetailModal"}
                                    viewDetails={viewDetails ? viewDetails : ""}
                                  />
                                  <a
                                    type="button"
                                    onClick={() => handleDelete(item._id)}
                                    className="btn btn-bg-dark action-hover"
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="16"
                                      height="16"
                                      fill="currentColor"
                                      className="bi bi-trash-fill"
                                      viewBox="0 0 16 16"
                                    >
                                      <path d="M2.5 1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1H3v9a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V4h.5a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H10a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1H2.5zm3 4a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 .5-.5zM8 5a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7A.5.5 0 0 1 8 5zm3 .5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 1 0z" />
                                    </svg>
                                  </a>
                                </td>
                              </tr>
                            );
                          })
                        ) : !not_found ? (
                          <div className="spinner-outer p-5">{loader()}</div>
                        ) : (
                          <div className="spinner-outer p-5">
                            <p>Data not found</p>
                          </div>
                        )}
                      </tbody>
                    </table>
                  </div>
                  <Pagination
                    pageSize={10}
                    items={AffiliateData}
                    onChangePage={onChangePage}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </Layout>
    </React.Fragment>
  );
};

const mapStateToProps = (state) => ({
  pageLoading: state?.affiliate?.loading,
  affiliateListData: state?.affiliate?.list,
  not_found: state?.affiliate?.not_found,
});

export default connect(mapStateToProps, { affiliateList })(AffiliateList);
